import {
  Dropdown,
  LeadsListListData,
  leadsListListInfiniteOptions,
  PaginatedDropdownList,
  PaginatedTaskTypeListReadable,
  TaskTypeReadable,
  TaskTypesListData,
  taskTypesListInfiniteOptions,
  UsersListListData,
  usersListListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect, RangePickerFilter } from '@crm/components'
import {
  defaultFiltersMultipleValues,
  listTransformResults,
  TagPriorityByValue
} from '@crm/utils'
import { MoreFiltersPopover } from '@shared/components'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { Select, Tooltip } from 'antd'

import { TaskStatus } from '../TaskStatus'

export const TaskFilter = () => {
  const { t } = useLocales()
  const { params, updateQuery } = useQueryUpdate()

  const filtersCount = ['lead', 'type', 'priority'].filter(
    (filter) => params?.[filter]
  )?.length

  const ownerValue = defaultFiltersMultipleValues(params?.owner)
  const leadValue = defaultFiltersMultipleValues(params?.lead, true)
  const created_byValue = defaultFiltersMultipleValues(params?.created_by)

  const typeValue = params?.type ? Number(params?.type) : undefined

  const onResetMoreFilters = () =>
    updateQuery({
      lead: undefined,
      type: undefined,
      priority: undefined
    })

  return (
    <>
      <TaskStatus />

      <InfiniteSelect<UsersListListData, PaginatedDropdownList, Dropdown>
        value={ownerValue}
        className="select-min-width"
        popupMatchSelectWidth
        placeholder={t('opportunities.responsible')}
        getQueryFunction={usersListListInfiniteOptions}
        onChange={(owner) => updateQuery({ owner })}
        baseOptions={{
          query: {
            preference: params?.owner
          }
        }}
        mode="multiple"
        maxTagCount={1}
        maxTagTextLength={6}
      />

      <InfiniteSelect<UsersListListData, PaginatedDropdownList, Dropdown>
        value={created_byValue}
        className="select-min-width"
        popupMatchSelectWidth
        placeholder={t('task.task_author')}
        getQueryFunction={usersListListInfiniteOptions}
        onChange={(created_by) => updateQuery({ created_by })}
        baseOptions={{
          query: {
            preference: params?.created_by
          }
        }}
      />

      <Tooltip title={`${t('deadline_start')} - ${t('deadline_end')}`}>
        <RangePickerFilter
          fromParam="deadline_start"
          toParam="deadline_end"
          placeholder={[t('deadline_start'), t('deadline_end')]}
        />
      </Tooltip>

      <MoreFiltersPopover
        filterActiveCount={filtersCount}
        onResetMoreFilters={onResetMoreFilters}
      >
        <InfiniteSelect<LeadsListListData, PaginatedDropdownList, Dropdown>
          value={leadValue}
          className="select-min-width"
          popupMatchSelectWidth
          mode="multiple"
          placeholder={t('filter.leads')}
          getQueryFunction={leadsListListInfiniteOptions}
          onChange={(lead) => updateQuery({ lead })}
          baseOptions={{
            query: {
              preference: params?.lead
            }
          }}
        />

        <InfiniteSelect<
          TaskTypesListData,
          PaginatedTaskTypeListReadable,
          TaskTypeReadable
        >
          value={typeValue}
          className="select-min-width"
          popupMatchSelectWidth
          placeholder={t('task.task_type')}
          getQueryFunction={taskTypesListInfiniteOptions}
          onChange={(type) => updateQuery({ type })}
          baseOptions={{
            query: {
              preference: typeValue ? [typeValue] : undefined
            }
          }}
          getOptions={({ options }) => listTransformResults(options)}
        />

        <Select
          allowClear
          value={params?.priority ? Number(params?.priority) : undefined}
          onChange={(priority) => updateQuery({ priority })}
          placeholder={t('task.priority')}
          options={Object.entries(TagPriorityByValue(t)).map(
            ([key, value]) => ({
              label: value.title,
              value: Number(key)
            })
          )}
        />
      </MoreFiltersPopover>
    </>
  )
}
